module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"8\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\"></circle><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M12 20c1.933 0 3.002-3.582 3.002-8s-1.07-8-3-8-2.998 3.582-2.998 8 1.064 8 2.997 8zm-8-8h16\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/language.svg
// module id = 1526
// module chunks = 0